import React from 'react';
import {Button, EMPHASIS} from '@forecast-it/design-system';

interface LoadMoreButtonProps {
	onClick: () => void;
	loading?: boolean;
	disabled?: boolean;
}

export function LoadMoreButton({onClick, loading = false, disabled = false}: LoadMoreButtonProps) {
	return (
		<Button emphasis={EMPHASIS.LOW} onPress={onClick} disabled={disabled || loading}>
			{loading ? 'Loading…' : 'Load more'}
		</Button>
	);
}
